import styled from 'styled-components';

const FaqStyle = styled.div`
	&.faq_section {
		--titleMarginBottom: var(--sp4x);
		--faqItemPadding: var(--sp4x) 0;
		--numberMarginRight: var(--sp3x);
		--titleWidth: unset;
		--descriptionWidth: unset;
		--titleMarginRight: unset;

		.faq_title {
			margin-bottom: var(--titleMarginBottom);

			span {
				&:last-child {
					font-weight: var(--ffLight);
				}
			}
		}

		.faqs_wrap {
			.faq_item {
				display: flex;
				flex-direction: row;
				padding: var(--faqItemPadding);
				border-top: 2px solid var(--black);
				opacity: 0;

				&:last-child {
					border-bottom: 2px solid var(--black);
				}

				.faq_number {
					margin-right: var(--numberMarginRight);
				}

				.content {
					width: 100%;

					.title {
						font-size: var(--pM);
						width: var(--titleWidth);
						margin-right: var(--titleMarginRight);
					}

					.description {
						width: var(--descriptionWidth);
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
			.content {
				.title {
					margin-bottom: var(--sp2x) !important;
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
			--titleMarginBottom: var(--sp5x);
			--faqItemPadding: var(--sp5x) 0;
			--numberMarginRight: var(--sp5x);
			--titleWidth: unset;
			--descriptionWidth: unset;
			--titleMarginRight: unset;

			.faqs_wrap {
				.faq_item {
					display: flex;

					.content {
						display: flex;
						flex-direction: column;
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) {
			--titleMarginBottom: var(--sp5x);
			--faqItemPadding: var(--sp5x) 0;
			--numberMarginRight: var(--sp5x);
			--titleWidth: 43.8%;
			--descriptionWidth: 51.5%;
			--titleMarginRight: var(--sp4x);

			.faqs_wrap {
				.faq_item {
					display: flex;
					flex-direction: row;

					.content {
						display: flex;
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) {
			--titleMarginBottom: var(--sp8x);
			--faqItemPadding: var(--sp6x) 0;
			--numberMarginRight: var(--sp6x);
			--titleWidth: 43.6%;
			--descriptionWidth: 52%;
			--titleMarginRight: var(--sp4x);

			.faqs_wrap {
				.faq_item {
					display: flex;
					flex-direction: row;

					.content {
						display: flex;
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) {
			--titleMarginBottom: var(--sp8x);
			--faqItemPadding: var(--sp6x) 0;
			--numberMarginRight: var(--sp7x);
			--titleWidth: 43.4%;
			--descriptionWidth: 52.9%;
			--titleMarginRight: var(--sp4x);

			.faqs_wrap {
				.faq_item {
					display: flex;
					flex-direction: row;

					.content {
						display: flex;
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) {
			--titleMarginBottom: var(--sp10x);
			--faqItemPadding: var(--sp8x) 0;
			--numberMarginRight: var(--sp9x);
			--titleWidth: 43.4%;
			--descriptionWidth: 52.9%;
			--titleMarginRight: var(--sp4x);

			.faqs_wrap {
				.faq_item {
					display: flex;
					flex-direction: row;

					.content {
						display: flex;
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) {
			--titleMarginBottom: var(--sp12x);
			--faqItemPadding: var(--sp8x) 0;
			--numberMarginRight: var(--sp12x);
			--titleWidth: 29.7%;
			--descriptionWidth: 53.2%;
			--titleMarginRight: var(--sp5x);

			.faqs_wrap {
				.faq_item {
					display: flex;
					flex-direction: row;

					.content {
						display: flex;
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--titleMarginBottom: var(--sp15x);
			--faqItemPadding: var(--sp8x) 0;
			--numberMarginRight: var(--sp13x);
			--titleWidth: 40.8%;
			--descriptionWidth: 39.5%;
			--titleMarginRight: var(--sp13x);

			.faqs_wrap {
				.faq_item {
					display: flex;
					flex-direction: row;

					.content {
						display: flex;
					}
				}
			}
		}
	}
`;

export default FaqStyle;
